import { ChatSocketContext } from "contexts/ChatSocketContext";
import { useContext } from "react";

function useChatSocket() {
  return useContext(ChatSocketContext);
}

export default useChatSocket;
